module.exports = __webpack_public_path__ + "media/Video1.8a750f05.mp4";